import { gql, useMutation } from '@apollo/client';

// whitelabelConfig fragment
export const WHITELABEL_CONFIG_FIELDS = gql`
  fragment WhitelabelConfigFields on WhitelabelConfig {
    id
    primaryColor
    secondaryColor
    successColor
    warningColor
    dangerColor
    domain
    emailFooter
    avatarName
    senderEmail
    senderName
    supportEmail
    logoUrl
    lightLogoUrl
    avatarUrl
    logoB64
    lightLogoB64
    avatarB64
    privacyUrl
    klausName
  }
`;

export const UPSERT_WHITELABEL_CONFIG = gql`
  ${WHITELABEL_CONFIG_FIELDS}
  mutation UpsertWhitelabelConfig(
    $primaryColor: String!
    $secondaryColor: String!
    $successColor: String
    $warningColor: String
    $dangerColor: String
    $domain: String
    $emailFooter: String
    $avatarName: String
    $senderEmail: String
    $senderName: String
    $supportEmail: String
    $privacyUrl: String
    $klausName: String
  ) {
    upsertWhitelabelConfig(
      primaryColor: $primaryColor
      secondaryColor: $secondaryColor
      successColor: $successColor
      warningColor: $warningColor
      dangerColor: $dangerColor
      domain: $domain
      emailFooter: $emailFooter
      avatarName: $avatarName
      senderEmail: $senderEmail
      senderName: $senderName
      supportEmail: $supportEmail
      privacyUrl: $privacyUrl
      klausName: $klausName
    ) {
      ...WhitelabelConfigFields
    }
  }
`;

export interface WhitelabelConfig {
  id: string;
  primaryColor: string;
  secondaryColor: string;
  successColor?: string;
  warningColor?: string;
  dangerColor?: string;
  domain?: string;
  emailFooter?: string;
  avatarName?: string;
  senderEmail?: string;
  senderName?: string;
  supportEmail?: string;
  logoUrl?: string;
  lightLogoUrl?: string;
  avatarUrl?: string;
  logoB64?: string;
  lightLogoB64?: string;
  avatarB64?: string;
  privacyUrl?: string;
  klausName?: string;
}

export interface WhitelabelConfigUpsertInput {
  primaryColor: string;
  secondaryColor: string;
  successColor?: string;
  warningColor?: string;
  dangerColor?: string;
  domain?: string;
  emailFooter?: string;
  privacyUrl?: string;
  avatarName?: string;
  senderEmail?: string;
  senderName?: string;
  supportEmail?: string;
  klausName?: string;
}

export interface WhitelabelConfigUpsertResult {
  upsertWhitelabelConfig: WhitelabelConfig;
}

export function useWhitelabelConfigUpsertMutation() {
  return useMutation<WhitelabelConfigUpsertResult, WhitelabelConfigUpsertInput>(UPSERT_WHITELABEL_CONFIG, {
    refetchQueries: ['GetCompany'],
    context: {
      headers: {
        'apollo-require-preflight': true, // Ensures the mutation process is handled correctly
      },
    },
  });
}
